import React, { useState, useEffect } from   'react';
import DataTable from 'react-data-table-component';
import { useForm } from 'react-hook-form';
import apiService from '../../Auth/apiService';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';  
import { FaArrowAltCircleRight, } from 'react-icons/fa';
import { useAuth } from '../../Auth/AuthContext';
import SeccionPageHeader from '../Utils/SeccionPageHeader';
import CargandoSpinner from '../Utils/CargandoSpinner';

export default function Modulos(){
    const { token } = useAuth();
    const [Cargando, setCargando] = useState(false);
    const [datos, setDatos] = useState([]);
    const { handleSubmit, register, setValue, formState: { errors }} = useForm();
    const [MuestraFormulario, setMuestraFormulario] = useState(false);
    const [swalProps, setSwalProps] = useState({});
    const columns = [
        {
            name: 'Acciones',
            cell: row => (
                <div>
                    <div className="btn-group">
                        <button type="button" className="btn btn-info" onClick={() => Editar(row)} 
                            data-tooltip-id='tooltiparriba'
                            data-tooltip-content="Editar">
                            <FaArrowAltCircleRight/>
                        </button>
                    </div>
                </div>
            ),
            ignoreRowClick: true,
            width: '7%'
        },
        { name: 'Id', selector: row => row.id, sortable: true, width: '7%' },
        { name: 'Módulo', selector: row => row.modModulo, sortable: true },
        { name: 'Activo', selector: row => row.modActivo ? 'Activo' : 'Inactivo', sortable: true },
    ];
    useEffect(() => {
        fetchData();
    }, []);
    const fetchData = async () => {
        const url = '/parametros/listarmodulos';
        try {
        setCargando(true);
        const response = await apiService.get(url, token);
        const result = await response.data;
        setDatos(result);
        } catch (error) {
        console.error('Error fetching data:', error);
        } finally {
        setCargando(false);
        }
    };
    function Editar (row){
        setMuestraFormulario(true);
        setValue('id', row.id);
        setValue('Nuevo', false);
        setValue('modModulo', row.modModulo);
        setValue('modActivo', row.modActivo);
    }
    const Nuevo = () =>  {
        setValue('id', 0);
        setValue('Nuevo', true);
        setValue('modModulo', '');
        setValue('modActivo', true);
        setMuestraFormulario(true);
    }
    const onSubmit = async (data) => {
        setCargando(true);
        let url;
        url = '/parametros/guardarmodulo';
        try {
            const response = await apiService.post(url, data, token);
            if(response.status === 200){
                Mensaje('Guardar', JSON.stringify(response.data));
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Guardar', JSON.stringify(error.response.data.errors));
            }else if(error.status === 409){
                Mensaje('Guardar', JSON.stringify(error.response.data));
            }
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
            fetchData();
            ResetForm();
        }
    };
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    const ResetForm = () => {
        setValue('id', 0);
        setValue('Nuevo', true);
        setValue('modModulo', '');
        setValue('modActivo', false);
        setMuestraFormulario(false);
    }
    return (
        <div className="content-wrapper">
            <SeccionPageHeader  
                title="Modulos"
                idCabezaFamilia="1"
                url="/parametros"
                nombreurl="Parámetros"
                nombreform=" Modulos"
            />
            <CargandoSpinner Cargando={Cargando}/>
            <section className="content">
                <div className="container-fluid">
                    {MuestraFormulario && <div className="card card">
                            <div className='card-header'>
                                <h3 className='card-title'>Formulario modulos</h3>
                            </div>
                            <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                                <div className="card-body">
                                    <input hidden {...register('id')}/>
                                    <input hidden {...register('Nuevo')}/>
                                    <div className="form-group row">
                                        <label htmlFor="modModulo" className="col-sm-2 col-form-label">M&oacute;dulo</label>
                                        <div className="col-sm-10">
                                            <input 
                                                type="text" 
                                                className={`form-control ${errors.modModulo ? 'is-invalid' : ''}`} 
                                                id="modModulo" 
                                                placeholder="Nombre del módulo" 
                                                {...register('modModulo', { required: 'El nombre del módulo es obligatorio' })}
                                            />
                                            {errors.modModulo && <div className="invalid-feedback">{errors.modModulo.message}</div>}
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label htmlFor="modActivo" className="col-sm-2 col-form-label">Activo</label>
                                        <div className="col-sm-10">
                                            <div className="custom-control custom-switch">
                                                <input type="checkbox" 
                                                    {...register('modActivo')}
                                                    className="custom-control-input" id="SwitchEstado"/>
                                                <label className="custom-control-label" htmlFor="SwitchEstado">Estado</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <div className='row'>
                                        <div className='col-md-1'>
                                            <button type="submit" className="btn btn-info">Guardar</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    }   
                    <div className="card card">
                        <div className="card-body">
                            <div className="card-body table-responsive p-0">
                                <div className='row'>
                                    <div className='col-md-2'>
                                        <button type="button" className='form-control' onClick={Nuevo}>Nuevo</button>
                                    </div>
                                </div>
                                <DataTable
                                    title="Lista de modulos por rol"
                                    columns={columns}
                                    data={datos}
                                    progressPending={Cargando}
                                    pagination
                                    noDataComponent="No hay datos para mostrar"
                                /> 
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
            <Tooltip id="tooltiparriba" place="right"/>
        </div>
    );
}